import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { CreditCardComponent } from '../../pages/create-adv/select-route/credit-card/credit-card.component';
import { BusinessService, PromotionOption, PromotionOptions } from '../../services/business.service';

/**
 * SCRUM-266 — promote an existing listing for a defined period.
 * Open to every advertiser (private or VIP). Shows the paid routes above the
 * listing's current one, then hands off to the shared card-payment dialog.
 * Closes with 'promoted' after a successful payment.
 */
@Component({
  selector: 'app-promote-ad-dialog',
  templateUrl: './promote-ad-dialog.component.html',
  styleUrls: ['./promote-ad-dialog.component.scss'],
  standalone: false,
})
export class PromoteAdDialogComponent implements OnInit {
  loading = true;
  error = '';
  data: PromotionOptions | null = null;
  selected: PromotionOption | null = null;
  starting = false;

  constructor(
    private business: BusinessService,
    private dialog: MatDialog,
    public ref: MatDialogRef<PromoteAdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public input: { adId: number; adName: string },
  ) {}

  ngOnInit(): void {
    this.business.promotionOptions(this.input.adId).subscribe({
      next: (d) => {
        this.data = d;
        this.selected = d.options[d.options.length - 1] || null;
        this.loading = false;
      },
      error: (e) => {
        this.loading = false;
        this.error = e?.error?.detail || 'לא הצלחנו לטעון את אפשרויות הקידום';
      },
    });
  }

  pay(): void {
    if (!this.selected || this.starting) return;
    this.starting = true;
    this.error = '';
    const option = this.selected;
    this.business.initiatePromotion(this.input.adId, option.route_id).subscribe({
      next: (session) => {
        this.starting = false;
        const adsRouteProxy = {
          id: option.route_id,
          title: session.title,
          description: `החשיפה הנוספת פעילה ${option.days} ימים ומסומנת "ממומן". היא מסתיימת בסוף התקופה או כשהמודעה יורדת.`,
          price: option.price,
          lifeSpan: option.days,
          image: '',
          level: option.level,
        };
        this.dialog
          .open(CreditCardComponent, {
            data: { adsRoute: adsRouteProxy, adsId: this.input.adId, promotionId: session.promotion_id },
            width: '760px',
            direction: 'rtl',
            panelClass: 'vip-payment-dialog',
          })
          .afterClosed()
          .subscribe((result) => {
            if (result === 'promoted') this.ref.close('promoted');
          });
      },
      error: (e) => {
        this.starting = false;
        this.error = e?.error?.detail || 'לא הצלחנו לפתוח תשלום, נסו שוב';
      },
    });
  }
}
